import React, { useContext } from 'react';

import * as FormSelectors from 'Pages/manageproduction/helpers/formSelectors';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';

import { CountSection } from './CountSection';
import { EditProductionFormContext } from './EditProductionForm';

function PlannedSection(props) {
  const state = useContext(EditProductionFormContext);
  const recipeCategoryIds = Object.keys(props.detailsByRecipeCategory);

  const feedingFigure = FormSelectors.getFeedingFigure(state);
  const feedingFigureAlacarte = FormSelectors.getFeedingFigureAlacarte(state);
  const feedingFigureAdult = FormSelectors.getFeedingFigureAdult(state);
  const reimbTotalsByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.ReimbursableMeals,
    recipeCategoryIds
  );
  const plannedPercByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.PlannedPercentage,
    recipeCategoryIds
  );
  const plannedPercMessagesByRecCat = FormSelectors.getPlannedPercMessagesByRecCat(
    state,
    recipeCategoryIds
  );
  const plannedAlacarteByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.PlannedAlacarte,
    recipeCategoryIds
  );
  const plannedAdultByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.PlannedAdult,
    recipeCategoryIds
  );
  const plannedTotalByRecCat = FormSelectors.getPlannedTotalByRecCat(
    state,
    recipeCategoryIds
  );
  const plannedPreKByRecCat = FormSelectors.getFieldTotalByRecCat(
    state,
    ProdRecordDetailFields.PlannedPreK,
    recipeCategoryIds
  );

  return (
    <CountSection
      {...props}
      headerProps={{
        feedingFigure,
        feedingFigureAdult,
        feedingFigureAlacarte,
        reimbTotalsByRecCat,
        plannedPercByRecCat,
        plannedPercMessagesByRecCat,
        plannedAlacarteByRecCat,
        plannedAdultByRecCat,
        plannedTotalByRecCat,
        plannedPreKByRecCat,
      }}
      rowProps={{ feedingFigure }}
    />
  );
}

export { PlannedSection };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/PlannedSection.js